import Vue from 'vue'
import Router from 'vue-router'
import Home from '../pages/home/home.vue'
import HomeOld from '../pages/home/home-old.vue'

import Product from '../pages/product/product.vue'
import CdrConvert from '../pages/product/cdrConvert.vue'
import CompanyDetails from '../pages/company/companyDetails.vue'
import CaseDetail from '../pages/case/CaseDetail.vue'
import Login from '../pages/login/login.vue'
import wxScan from '../pages/login/wxScan.vue'
import wxLoginBack from '../pages/login/wxLoginBack.vue'
import wxLoginBackRegister from '../pages/login/wxLoginBackRegister.vue'
import Logout from '../pages/login/logout.vue'
import Registe from '../pages/login/registe.vue'
import RegisteSuccess from '../pages/login/registeSuccess'
import Preview from '../pages/product/preview.vue'
import Search from '../pages/home/search.vue'
import SearchOld from '../pages/home/search-old.vue'
import About from '../pages/home/about.vue'
import Business from '../pages/home/business.vue'
import CaseSearch from '../pages/home/caseSearch.vue'
import Demand from '../pages/demand/demand.vue'
import Tologin from '../pages/login/tologin.vue'
import quickEnterIn from '../pages/enterprise/quickEnterIn.vue'
import quickEnterInNew from '../pages/enterprise/quickEnterInNew.vue'

// import Newtv from '../pages/home/tv.vue'


import enterpriseEnterInPolicy from '../pages/agreement/enterpriseEnterInPolicy.vue'
import demandDetail from '../pages/demand/demandDetail.vue'
import societyAbout from '../pages/society/societyAbout.vue'
import societyIndex from '../pages/society/societyIndex.vue'
import zTree from '../pages/zTree/zTree.vue'
import SocietyArticleNews from '../pages/societyArticleNews/societyArticleNews.vue'
import SocietyArticleNewsDetail from '../pages/societyArticleNews/societyArticleNewsDetail.vue'
import Force from '../pages/societyArticleNews/force.vue'
import CompanyDetailNew from '../pages/company/companyDetailNew.vue'
import CompanyDetailNewOld from '../pages/company/companyDetailNew-old.vue'
// import CompanyDetailNewPBL from '../pages/company/companyDetailNewPBL.vue'
import List from '../pages/company/list.vue'
import Waterfall from '../pages/company/waterfall.vue'
import Full from '../pages/full/full.vue'
import Grid from '../pages/grid/grid.vue'

import GridOld from '../pages/grid/gridOld.vue'
import AppPubMain from '../pages/appPub/appPubMain.vue'
import AppDetail from '../pages/appPub/appDetail.vue'
import Not from '../pages/not/404.vue'


Vue.use(Router)
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
const originalReplace = Router.prototype.replace
Router.prototype.replace = function replace(location) {
  return originalReplace.call(this, location).catch(err => err)
}
const router = new Router({
  base: process.env.NODE_ENV === 'production' ? '/preweb':'/',
  mode: 'history',
  routes: [
    {
      path: '/index',
      name: '觅圈圈',
      component: Home,
      meta: {title: '觅圈圈'},
      children: []
    },
    {
      path: '/companyDetails',
      name: '企业详情废弃',
      component: CompanyDetails,
      meta: {title: '企业详情废弃'},
      children: []
    },
    {
      path: '/companyDetailNew',
      name: '企业详情基础版',
      component: CompanyDetailNew,
      meta: {title: '企业详情基础版'},
      children: []
    },
    {
      path: '/companyDetailNew-old',
      name: '企业详情',
      component: CompanyDetailNewOld,
      meta: {title: '企业详情'},
      children: []
    },
    // {
    //   path: '/companyDetailNewPBL',
    //   name: '企业详情',
    //   component: CompanyDetailNewPBL,
    //   meta: {title: '企业详情瀑布流'},
    //   children: []
    // },
    {
      path: '/business',
      name: '找业务',
      component: Business,
      meta: {title: '找业务'},
      children: []
    },
    {
      path: '/list',
      name: '协会列表',
      component: List,
      meta: {title: '协会列表'},
      children: []
    },
    {
      path: '/waterfall',
      name: '瀑布流',
      component: Waterfall,
      meta: {title: '瀑布流'},
      children: []
    },
    {
      path: '/search',
      name: '找合作',
      component: Search,
      meta: {title: '找合作'},
      children: []
    },
    {
      path: '/about',
      name: '关于我们',
      component: About,
      meta: {title: '关于我们'},
      children: []
    }, 
    {
      path: '/force',
      name: '详情',
      component: Force,
      meta: {title: '详情'},
      children: []
    },
    {
      path: '/caseSearch',
      name: '找案例',
      component: CaseSearch,
      meta: {title: '找案例'},
      children: []
    },
    {
      path: '/product',
      name: '产品案例',
      component: Product,
      meta: {title: '产品案例'},
      children: []
    },
    {
      path: '/cdrConvert',
      name: 'AI报价',
      component: CdrConvert,
      meta: {title: 'AI报价'},
      children: []
    },
    {
      path: '/preview',
      name: 'AI报价预览',
      component: Preview,
      meta: {title: 'AI报价预览'},
      children: []
    },
    {
      path: '/caseDetail',
      name: '方案详情',
      component: CaseDetail,
      meta: {title: '方案详情'},
      children: []
    },
    {
      path: '/login',
      name: '登录',
      component: Login,
      meta: {title: '登录'},
      children: []
    },
    {
      path: '/wxScan',
      name: 'wxScan',
      component: wxScan,
      meta: {title: '微信扫码'},
      children: []
    },
    {
      path: '/wxLoginBack',
      name: 'wxLoginBack',
      component: wxLoginBack,
      meta: {title: '微信登录回调'},
      children: []
    },
    {
      path: '/wxLoginBackRegister',
      name: 'wxLoginBackRegister',
      component: wxLoginBackRegister,
      meta: {title: '微信登录回调'},
      children: []
    },
    {
      path: '/registe',
      name: '注册',
      component: Registe,
      meta: {title: '注册'},
      children: []
    },
    {
      path: '/logout',
      name: '退出',
      component: Logout,
      meta: {title: '退出'},
      children: []
    },
    {
      path: '/registeSuccess',
      name: '注册成功',
      component: RegisteSuccess,
      meta: {title: '注册成功'},
      children: []
    },
    {
      path: '/demand',
      name: '供需平台2级',
      component: Demand,
      meta: {title: '供需平台2级'},
      children: []
    },
    {
      path: '/demandDetail',
      name: '需求详情',
      component: demandDetail,
      meta: {title: '需求详情'},
      children: []
    },
    {
      path: '/societyIndex',
      name: '协会主页',
      component: societyIndex,
      meta: {title: '协会主页'},
      children: []
    },
    {
      path: '/societyArticleNews',
      name: '文章资讯列表',
      component: SocietyArticleNews,
      meta: {title: '文章资讯列表'},
      children: []
    },
    {
      path: '/societyArticleNewsDetail',
      name: '文章资讯详情',
      component: SocietyArticleNewsDetail,
      meta: {title: '文章资讯详情'},
      children: []
    },
    {
      path: '/HomeOld',
      name: '历史首页',
      component: HomeOld,
      meta: {title: '历史首页'},
      children: []
    },
    {
      path: '/SearchOld',
      name: '历史搜索页',
      component: SearchOld,
      meta: {title: '历史搜索页'},
      children: []
    },
    {
      path: '/grid',
      name: '网格宣传',
      component: Grid,
      meta: {title: '网格宣传'},
      children: []
    },
    {
      path: '/gridOld',
      name: '网格宣传老版',
      component: GridOld,
      meta: {title: '网格宣传老版'},
      children: []
    },
    {
      path: '/full',
      name: 'default',
      component: Full,
      meta: {title: 'default'},
      children: []
    },
    {
      path: '/ztree',
      name: 'default',
      component: zTree,
      meta: {title: 'default'},
      children: []
    },
    {
      path: '/appPubMain',
      name: '应用中心',
      component: AppPubMain,
      meta: {title: '应用中心'},
      children: []
    },
    {
      path: '/appDetail',
      name: '应用详情',
      component: AppDetail,
      meta: {title: '应用详情'},
      children: []
    },
    {
      path: '/tologin',
      name: '登录跳转',
      component: Tologin,
      meta: {title: '登录跳转'},
      children: []
    },
    {
      path: '/',
      name: '',
      component: Home,
      meta: {title: '觅圈圈'},
      redirect: '/index',
    },
    {
      path: '*',
      name: '',
      component: Home,
      meta: {title: '觅圈圈'},
      redirect: '/index',
    },
    {
      path: '/platformServiceAgreement',
      name: 'platformServiceAgreement',
      component: () => import('@/pages/agreement/platformServiceAgreement'),
      meta: {title: '服务协议',whiteList:true},
      children: []
    },
    {
      path: '/enterpriseEnterInPolicy',
      name: 'enterpriseEnterInPolicy',
      component: () => import('@/pages/agreement/enterpriseEnterInPolicy'),
      meta: {title: '平台入驻协议',whiteList:true},
      children: []
    },
    {
      path: '/platformPrivacypolicy',
      name: 'platformPrivacypolicy',
      component: () => import('@/pages/agreement/platformPrivacypolicy'),
      meta: {title: '隐私保护政策',whiteList:true},
      children: []
    },
    {
      path: '/not',
      name: '需更换浏览器',
      component: Not,
      meta: {title: '需更换浏览器'},
      children: []
    },
    {
      path: '/quickEnterIn',
      name: 'quickEnterIn',
      component: quickEnterIn,
      meta: {title: '入驻平台'},
      children: []
    },
    {
      path: '/quickEnterInNew',
      name: 'quickEnterInNew',
      component: quickEnterInNew,
      meta: {title: '快速入驻平台（内部）'},
      children: []
    },
    {
      path: '/societyAbout',
      name: 'societyAbout',
      component: societyAbout,
      meta: {title: '协会简介'},
      children: []
    },

  ]
})
// 路由守卫
router.beforeEach((to,from,next)=>{
  document.documentElement.scrollTop = 0
  if (from.path != '/login' && from.path!='/registe' &&from.path != '/wxScan') {
    localStorage.setItem('fromPage', from.path)
    localStorage.setItem('fromPageQuery',JSON.stringify(from.query))
  }
  next()

})
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js